<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 mt-5 mx-auto">
        <form v-on:submit.prevent="login">
          <h1 class="h3 mb-3 font-weight-normal">Bejelentkezés</h1>
          <div class="form-group">
            <label for="email">Email cím</label>
            <input type="email" v-model="email" class="form-control" name="email" placeholder="Enter email">
          </div>
          <div class="form-group">
            <label for="password">Jelszó</label>
            <input type="password" v-model="password" class="form-control" name="password" placeholder="Password">
          </div>
          <button type="submit" class="btn btn-lg btn-primary btn-block">Bejelentkezés</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import EventBus from './EventBus'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },

  methods: {
    login () {
      axios.post('http://'+process.env.ROOT_API+'/users/login',
        {
          email: this.email,
          password: this.password
        }
      ).then((res) => {
        localStorage.setItem('usertoken', res.data)
        let token = localStorage.usertoken
        let decoded = jwtDecode(token)
        localStorage.setItem('userType', decoded.usertype)
        localStorage.setItem('auth', 'loggedin')
        this.email = ''
        this.password = ''
        this.emitMethod()
        router.push({ name: 'Home' })
      }).catch((err) => {
        console.log(err)
      })
    },
    emitMethod () {
      EventBus.$emit('logged-in', 'loggedin')
    }
  },
  mounted () {
    localStorage.removeItem('usertoken')
    localStorage.removeItem('userType')
    localStorage.removeItem('auth')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue